import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../environments/environment';
import { Articolo } from '../models/Articolo';

import { SharedService } from './shared.service';

@Injectable()
export class ArticoloService {

  selectedId: string;

  get selected(): string {
    return this.selectedId;
  }
  set selected(_id: string) {
    this.selectedId = _id;
  }

  constructor(public sharedService: SharedService, private http: Http) { }

  search(q): Observable<any> {
    return this.http.post(environment.server.url + '/articolo/search', q)
      .map(response => response.json())
  }

  getArticolo(_id: string) {
    return this.http.post(environment.server.url + '/articolo/find-one', { id: _id })
      .map(response => response.json())
  }

  getEan13(anno: number, numero: number) {
    return this.http.post(environment.server.url + '/articolo/getEan13', { anno: anno, numero: numero })
      .map(response => response.json())
  }

  persist(wmodel: any) {
    console.log('persist', wmodel)
    return this.http.post(environment.server.url + '/articolo/persist', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('persist', r)
        if (r.success) {
          console.log('persist - emit', r.result.value)
          this.sharedService.sharedEmitter.emit(r.result.value)
        }
        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  remove(wmodel: Articolo) {
    console.log('remove articolo', wmodel)
    return this.http.post(environment.server.url + '/articolo/remove', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('remove articolo', r)
        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  readTipiArticoli(): Observable<any> {
    return this.http.post(environment.server.url + '/articolo/tipi-articoli', {})
      .map(response => response.json())
  }

  callAlfrescoEndpoint(anno: number, numero: number): Observable<any> {
    console.log('================== callAlfrescoEndpoint: ', anno, numero);
    // return this.http.get('http://212.210.69.58:8080/alfresco/service/getDocList?guest=true&&folder=Pubblicazione&maxitems=10000&site=testimoni&numero=' + anno + '-' + numero)
    //   .map(response => response.json())
    return this.http.get('https://alfresco.ilporticoeditoriale.it/alfresco/service/getDocList?guest=true&&folder=Pubblicazione&maxitems=10000&site=testimoni&numero=' + anno + '-' + numero)
      .map(response => response.json())
  }

  private handleError(error: Response | any) {
    console.error(error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/articolo.service.ts